<template>
	<div class="repair-list-wrap flex">
		<div class='dynamics-wrap'>
			<div class="list-wrap wrap-border">
				<ul class="" v-if="list.length>0">
					<li class="" v-for="item in list" :key="item.id">
						<router-link :to="`/common/article/10/${item.createDate}`" tag="a">
							<div class="flex" :title="item.name">
								<p class="ellipsis-1">{{item.name}}</p>
								<!-- <p class="ellipsis-1 source-wrap flex flex-row-end"><span class="source">来源</span><span>{{item.source}}</span></p> -->
								<p>{{item.createDate}}</p>
							</div>
							<div class="list-brief flex">
								<p class="ellipsis-1 source-wrap flex flex-row-start"><span class="source">专栏</span><span>信用修复</span></p>
							</div>
						</router-link>
					</li>
				</ul>
				<empty v-else />
			</div>
			<el-pagination v-if="list.length>0" background layout="total, prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange" />
		</div>

		<div class="right-wrap">
			<commonRight :recommend="[]" :isArticle="true" routerZhName="信用修复" />
		</div>
	</div>
</template>

<script>
import { creditRepairsPage } from '@/api';
import { page } from '@/mixins/page.js';
import commonRight from '@/components/common-right'
import empty from '@/components/empty';

export default {
	components: {
		commonRight,
		empty
	},
	// mixins: [page],
	data() {
		return {
			list: [],
			total: 0,
			pageSize: 10
		};
	},

	mounted() {
		this.$emit('layoutInit', {
			menus: '信用修复'
		})
		this.getList(1)
	},
	methods: {

		getList(page = 1) {
			creditRepairsPage({ current: page }).then(res => {
				const { records, current, total } = res || {};
				this.$set(this, 'list', records);
			})
		},

		handleCurrentChange(e) {
			this.getList(e);
		}
	},

};
</script>

<style  lang="scss">
	@import '../../assets/css/left.scss';

	.repair-list-wrap {
		align-items: flex-start;
		.right-wrap {
			width: calc(100% - 20px - 775px);
		}
		.dynamics-wrap {
			width: 775px;
			padding-top: 0;
			margin-left: 0;

			.list-brief {
				.source-wrap {
					padding: 0 !important;
					span {
						border-right: 0 !important;
					}
				}
			}
		}
	}
</style>